"use client";

import { Typography } from "@components";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getTransitions } from "i18n";
import React, { FC } from "react";

import { CurrentEarnings, InvestmentChart, SearchForm } from "./components";
import ChartFooter from "./components/chart-footer";

export const RegularInvestment: FC = () => {
  const t = getTransitions();

  const EarningsTips: FC = () => (
    <Typography.Muted className="flex items-start gap-2 text-xs leading-3">
      <FontAwesomeIcon icon={faInfoCircle} />
      {t("asset_dashboard.short_term_yield_desc")}
    </Typography.Muted>
  );
  return (
    <div className="flex size-full flex-1 gap-2">
      <div className="flex w-[350px] flex-none flex-col gap-4">
        <CurrentEarnings id="tour-1" />
        <EarningsTips />
        <div className="overflow-scroll">
          <SearchForm id="tour-2" />
        </div>
      </div>
      <div className="top-1/2 mx-4 h-auto w-1 rounded-full bg-secondary" />
      <div className="flex w-full flex-col gap-2" id="tour-3">
        <div className="flex-1">
          <InvestmentChart />
        </div>
        <ChartFooter />
      </div>
    </div>
  );
};
